import * as Types from '../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type AuthenticationQueryVariables = {};


export type AuthenticationQuery = (
  { __typename?: 'Query' }
  & { principal: Types.Maybe<(
    { __typename?: 'User' }
    & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'upn' | 'department' | 'email' | 'avatarUrl' | 'roles' | 'external' | 'calendarLink' | 'signature' | 'companyName' | 'userType'>
  )> }
);

export const AuthenticationDocument = gql`
    query Authentication {
  principal {
    _id
    type
    name
    firstName
    lastName
    upn
    department
    email
    avatarUrl(size: 64)
    roles
    external
    calendarLink
    signature
    companyName
    userType
  }
}
    `;

    export function useAuthenticationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AuthenticationQuery, AuthenticationQueryVariables>) {
      return ApolloReactHooks.useQuery<AuthenticationQuery, AuthenticationQueryVariables>(AuthenticationDocument, baseOptions);
    };
      export function useAuthenticationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AuthenticationQuery, AuthenticationQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<AuthenticationQuery, AuthenticationQueryVariables>(AuthenticationDocument, baseOptions);
      };
      
export type AuthenticationQueryHookResult = ReturnType<typeof useAuthenticationQuery>;
export type AuthenticationQueryResult = ApolloReactCommon.QueryResult<AuthenticationQuery, AuthenticationQueryVariables>;